import '../../pages/teamDashboardPage/accountGuidedTraining.scss';

import { observer } from 'mobx-react-lite';
import React from 'react';

import { Button } from '../input';
import { GuidedTrainingMask } from '../../pages/teamDashboardPage/guidedTrainingMask';
import { CreateFirstLibraryGuidedTrainingState } from './createFirstLibraryGuidedTrainingState';

type Props = {
  model: CreateFirstLibraryGuidedTrainingState;
};

export const CreateFirstLibraryGuidedTraining = observer(({ model }: Props) => {
  if (!model.isVisible) return null;

  return (
    <section
      className="account-guided-training"
      aria-label="CLIPr first library guided training">
      <GuidedTrainingMask targetRect={model.targetRect} fullScreen={!model.targetRect} />

      <div
        className="guided-training-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="create-first-library-guided-training-title"
        aria-describedby="create-first-library-guided-training-description"
        style={{
          top: model.coachPosition.top,
          left: model.coachPosition.left,
          width: model.coachPosition.width,
        }}>
        <div className="guided-training-eyebrow">Guided Training</div>
        <h2 id="create-first-library-guided-training-title">Let's create your first Library</h2>
        <p id="create-first-library-guided-training-description">
          This is where you store all your uploaded recordings. For your first Library, we recommend using your first and last name followed by your full email address, like First Last Name - full email address.
        </p>

        <footer className="guided-training-actions">
          <Button
            className="primary medium"
            label="Create Library"
            onClick={model.next}
          />
        </footer>
      </div>
    </section>
  );
});
